/**
 * Onlayn do‘kon: default — qisqa marshrut `/{MARKETING_SHOP_PATH_PREFIX}/{segment}` (masalan /s/42).
 * Subdomen: faqat `VITE_SHOP_USE_SUBDOMAIN=true` + wildcard DNS/SSL bo‘lsa.
 * `.env`: REACT_APP_SHOP_ROOT_DOMAIN=adde.app — havolada asosiy domen (marshrut /s/… uchun).
 */
/** Bitta harfli prefiks — URL ni iloji boricha qisqa tutish uchun */
export const MARKETING_SHOP_PATH_PREFIX = 's';

function readShopEnv(_viteKey, reactKey) {
  try {
    if (typeof process !== 'undefined' && process.env && process.env[reactKey] != null) {
      const s = String(process.env[reactKey]).trim();
      if (s !== '') return s;
    }
  } catch {
    // ignore
  }
  return '';
}

export function getMarketingShopRootDomain() {
  const raw = readShopEnv('VITE_SHOP_ROOT_DOMAIN', 'REACT_APP_SHOP_ROOT_DOMAIN');
  if (raw === '') return '';
  const lower = raw.toLowerCase();
  /** "app" kabi bitta label — TLD xato; e'tiborsiz qoldiramiz */
  if (!lower.includes('.')) return '';
  return lower;
}

/**
 * Joriy brauzer hostname dan registratsiya domenini taxmin qiladi.
 * admin.adde.app → adde.app; www.adde.app → adde.app; localhost → ""
 */
export function inferShopRootDomainFromHostname(hostname) {
  if (!hostname || typeof hostname !== 'string') return '';
  const h = hostname.toLowerCase().trim();
  if (h === 'localhost' || h === '127.0.0.1' || h.endsWith('.local')) return '';
  if (/^\d{1,3}(\.\d{1,3}){3}$/.test(h)) return '';
  const parts = h.split('.').filter(Boolean);
  if (parts.length < 2) return '';
  if (parts[0] === 'www') parts.shift();
  if (parts.length < 2) return parts.join('.') || '';
  return parts.slice(-2).join('.');
}

/**
 * Subdomen havolasi — faqat deploymentda `*.domen` SSL va DNS bo‘lsa yoqing.
 * Default: false → `https://{ROOT}/s/{segment}` marshrut.
 */
export function isMarketingShopSubdomainUrlEnabled() {
  const v = readShopEnv('VITE_SHOP_USE_SUBDOMAIN', 'REACT_APP_SHOP_USE_SUBDOMAIN').toLowerCase();
  return v === '1' || v === 'true';
}

/**
 * Marshrut orqali do‘kon URL (subdomen emas).
 * Eski `VITE_SHOP_FORCE_PATH_URL` — endi default path; subdomen faqat `VITE_SHOP_USE_SUBDOMAIN=true`.
 */
export function isShopPublicUrlPathOnly() {
  return !isMarketingShopSubdomainUrlEnabled();
}

/**
 * Avvalo VITE_SHOP_ROOT_DOMAIN; bo‘lmasa joriy hostdan (masalan adde.app).
 */
export function getEffectiveShopRootDomain() {
  const fromEnv = getMarketingShopRootDomain();
  if (fromEnv) return fromEnv;
  if (typeof window !== 'undefined' && window.location?.hostname) {
    return inferShopRootDomainFromHostname(window.location.hostname);
  }
  return '';
}

/**
 * Do‘kon havolasi uchun asos (path rejimida): ROOT domen + protokol; bo‘lmasa joriy origin.
 */
export function getMarketingShopPublicOrigin() {
  const protocol =
    typeof window !== 'undefined' && window.location?.protocol === 'http:' ? 'http' : 'https';
  const root = getEffectiveShopRootDomain();
  if (root) return `${protocol}://${root}`;
  if (typeof window !== 'undefined' && window.location?.origin) return window.location.origin;
  return '';
}

/**
 * Brauzer hostname dan marketing subdomenini ajratadi.
 * Apex faqat hostname dan hisoblanadi — `REACT_APP_SHOP_ROOT_DOMAIN=app` kabi xato qiymat
 * `adde.app` ni `*.app` deb talqin qilib landing o‘rniga do‘kon sahifasini ochmasligi uchun.
 * @returns {string} masalan "dilshod-market" yoki ""
 */
export function getMarketingShopSubdomainFromHost(hostname) {
  if (!hostname) return '';
  const host = String(hostname).toLowerCase();
  const apex = inferShopRootDomainFromHostname(host);
  if (!apex) return '';
  if (host === apex || host === `www.${apex}`) return '';
  const suffix = `.${apex}`;
  if (!host.endsWith(suffix)) return '';
  const sub = host.slice(0, -suffix.length);
  if (!sub || sub.includes('.')) return '';
  return sub;
}
